const INITIAL_STATE = {
  data: {},
  errors: {},
}
    
const getBillingAddress = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_BILLING_ADDRESS_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_BILLING_ADDRESS_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default getBillingAddress;
    